/** Runtime type of a property value, used to pick the right edit control and to prevent type drift on save. */
export type PropertyValueType = "string" | "number" | "boolean" | "object" | "array" | "null";

/** One row of the properties editor: an existing or newly-added key/value pair. */
export interface PropertyRow {
  key: string;
  value: unknown;
  type: PropertyValueType;
  locked: boolean;
  isNew: boolean;
}

/** Detects the runtime type of a property value so the editor can preserve it across edits. */
export function detectPropertyValueType(value: unknown): PropertyValueType {
  if (value === null || value === undefined) return "null";
  if (Array.isArray(value)) return "array";
  const t = typeof value;
  return t === "number" || t === "boolean" || t === "string" ? t : "object";
}
